!function () {
  "use strict";

  if (customElements.get("buy-box-tiers")) return;

  customElements.define("buy-box-tiers", class extends HTMLElement {
    constructor() {
      super();
      this.tiers = this.querySelectorAll("[data-tier-qty]");
      this.atcButton = this.querySelector("[data-buy-box-atc]");
      this.atcText = this.querySelector("[data-buy-box-atc-text]");
      this.variantPrice = parseInt(this.getAttribute("data-variant-price"), 10) || 0;
      this.moneyFormat = this.getAttribute("data-money-format") || "${{amount}}";
      this.selectedTier = null;
      this.section = null;
      this.realAddBtn = null;
      this.qtyInput = null;
      this.qtyHidden = null;
    }

    connectedCallback() {
      this.section = this.closest("[data-section-type='product']");

      if (this.section) {
        this.realAddBtn = this.section.querySelector("[data-add-to-cart]");
        this.qtyInput = this.section.querySelector(".quantity__input");
        this.qtyHidden = this.section.querySelector("input[type='hidden'][name='quantity']");

        /* Hide the original buttons block when buy box is active */
        var buttonsBlock = this.section.querySelector(".product__block--buttons");
        if (buttonsBlock) {
          buttonsBlock.style.display = "none";
        }
      }

      var self = this;

      this.tiers.forEach(function (tier) {
        tier.addEventListener("click", function (e) {
          e.preventDefault();
          self.selectTier(tier);
        });
      });

      /* Integrated ATC click */
      if (this.atcButton) {
        this.atcButton.addEventListener("click", function (e) {
          e.preventDefault();
          self.addToCart();
        });
      }

      /* Select first tier by default */
      if (this.tiers.length > 0) {
        this.selectTier(this.tiers[0]);
      }

      /* Listen for variant changes to update all prices */
      if (this.section) {
        this.section.addEventListener("theme:variant:change", function (e) {
          if (e.detail && e.detail.variant) {
            self.variantPrice = e.detail.variant.price;
            self.updateAllTierPrices();
            self.updateAtcText();

            /* Update disabled state */
            if (self.atcButton) {
              if (e.detail.variant.available) {
                self.atcButton.removeAttribute("disabled");
              } else {
                self.atcButton.setAttribute("disabled", "disabled");
              }
            }
          }
        });
      }
    }

    selectTier(tier) {
      /* Update active state */
      this.tiers.forEach(function (t) {
        t.classList.remove("is-active");
      });
      tier.classList.add("is-active");
      this.selectedTier = tier;

      /* Get quantity */
      var qty = parseInt(tier.getAttribute("data-tier-qty"), 10) || 1;

      /* Update the real form quantity */
      if (this.qtyInput) {
        this.qtyInput.value = qty;
        this.qtyInput.dispatchEvent(new Event("change", { bubbles: true }));
      } else if (this.qtyHidden) {
        this.qtyHidden.value = qty;
      }

      /* Update ATC button text */
      this.updateAtcText();
    }

    updateAllTierPrices() {
      var self = this;

      this.tiers.forEach(function (tier) {
        /* Skip ATC button which also has data-buy-box-atc */
        var priceEl = tier.querySelector(".buy-box__tier-price");
        if (!priceEl) return;

        var qty = parseInt(tier.getAttribute("data-tier-qty"), 10) || 1;
        var freeQty = parseInt(tier.getAttribute("data-tier-free"), 10) || 0;
        var paidQty = qty - freeQty;
        var total = self.variantPrice * paidQty;

        if (freeQty > 0) {
          /* Deal tier: show paid price + strikethrough full price */
          var fullTotal = self.variantPrice * qty;
          priceEl.innerHTML = self.formatMoney(total) +
            ' <span class="buy-box__tier-was">' + self.formatMoney(fullTotal) + '</span>';
        } else {
          priceEl.textContent = self.formatMoney(total);
        }

        /* Update savings badge */
        var savingsEl = tier.querySelector(".buy-box__tier-savings");
        if (savingsEl && freeQty > 0) {
          savingsEl.textContent = "Save " + self.formatMoney(self.variantPrice * freeQty);
        }
      });
    }

    updateAtcText() {
      if (!this.atcText || !this.selectedTier) return;

      var qty = parseInt(this.selectedTier.getAttribute("data-tier-qty"), 10) || 1;
      var freeQty = parseInt(this.selectedTier.getAttribute("data-tier-free"), 10) || 0;
      var paidQty = qty - freeQty;
      var total = this.variantPrice * paidQty;

      if (this.atcButton && this.atcButton.hasAttribute("disabled")) {
        this.atcText.textContent = "SOLD OUT";
        return;
      }

      this.atcText.textContent = "ADD TO CART \u2014 " + this.formatMoney(total);
    }

    formatMoney(cents) {
      var amount = (cents / 100).toFixed(2);
      return this.moneyFormat
        .replace("{{amount}}", amount)
        .replace("{{amount_no_decimals}}", Math.round(cents / 100))
        .replace("{{amount_with_comma_separator}}", amount.replace(".", ","))
        .replace("{{amount_no_decimals_with_comma_separator}}", Math.round(cents / 100));
    }

    addToCart() {
      if (!this.realAddBtn || this.atcButton.hasAttribute("disabled")) return;

      /* Show loading state */
      this.atcButton.classList.add("is-loading");

      /* Click the real hidden add-to-cart button */
      this.realAddBtn.click();

      /* Remove loading state when product is actually added to cart
         instead of waiting a fixed 2 seconds */
      var self = this;
      var fallback = setTimeout(function () {
        self.atcButton.classList.remove("is-loading");
      }, 5000);

      document.addEventListener("theme:product:added", function onAdded() {
        clearTimeout(fallback);
        self.atcButton.classList.remove("is-loading");
        document.removeEventListener("theme:product:added", onAdded);
      });
    }
  });
}();
